import {
  CREATE_PILOTAGE_VOLUME,
  DELETE_ALL_PILOTAGE_VOLUME,
  DELETE_PILOTAGE_VOLUME,
  GET_PILOTAGE_VOLUME_WITH_PAGINATION,
  SEARCH_PILOTAGE_VOLUME,
  UPDATE_ALL_PILOTAGE_VOLUME,
  UPDATE_PILOTAGE_VOLUME,
} from '../types/pilotageVolumeTypes';
import { removeDuplicates } from './helper';
import { ACCOUNT_LOGOUT } from '../types/accountTypes';
import initialState from '../../store/initialState';

const keys = ['campaignId', 'companyLabel', 'groupLabel', 'codeCommunication'];
const deleteVolume = (volumes, volume) => volumes.filter((v) => JSON.stringify(v) !== JSON.stringify(volume));

const deleteAllVolume = (volumes, deletedVolumes) => {
  const map = {};
  deletedVolumes.forEach((el) => {
    map[JSON.stringify(el)] = true;
  });
  return volumes.filter((v) => !map[JSON.stringify(v)]);
};

const combineElementWithArrayAndRemoveDuplicate = (array, element) => {
  return removeDuplicates([element, ...array], keys).filter((e) => e !== null);
};

const combineArraysAndRemoveDuplicate = (array1, array2) => {
  return removeDuplicates([...array2, ...array1], keys).filter((e) => e !== null);
};

const pilotageVolumeReducer = function (state = initialState.pilotageVolume, action) {
  switch (action.type) {
    case GET_PILOTAGE_VOLUME_WITH_PAGINATION:
      return {
        ...state,
        pilotageVolumes: action.payload.pilotageVolumes,
        pageNumber: action.payload.pageNumber,
        totalCount: action.payload.totalCount,
        pageSize: action.payload.pageSize || state.pageSize,
      };
    case CREATE_PILOTAGE_VOLUME:
      return {
        ...state,
        pilotageVolumes: combineElementWithArrayAndRemoveDuplicate(state.pilotageVolumes, action.payload),
        totalCount: state.totalCount + 1,
      };
    case UPDATE_PILOTAGE_VOLUME:
      return {
        ...state,
        pilotageVolumes: combineElementWithArrayAndRemoveDuplicate(state.pilotageVolumes, action.payload),
      };

    case UPDATE_ALL_PILOTAGE_VOLUME:
      return {
        ...state,
        pilotageVolumes: combineArraysAndRemoveDuplicate(state.pilotageVolumes, action.payload),
      };

    case DELETE_PILOTAGE_VOLUME:
      return {
        ...state,
        pilotageVolumes: deleteVolume(state.pilotageVolumes, action.payload),
        totalCount: state.totalCount - 1,
      };

    case DELETE_ALL_PILOTAGE_VOLUME:
      return {
        ...state,
        pilotageVolumes: deleteAllVolume(state.pilotageVolumes, action.payload),
        totalCount: state.totalCount - action.payload.length,
      };

    case SEARCH_PILOTAGE_VOLUME:
      return {
        ...state,
        pilotageVolumes: action.payload,
        pageNumber: 0,
        totalCount: action.payload.length,
      };
    case ACCOUNT_LOGOUT:
      return {
        ...initialState.pilotageVolume,
      };
    default:
      return state;
  }
};

export default pilotageVolumeReducer;
